<template>
	<div class="pb-3 bg-white rounded-cus cus-box-shadow shop-cart">
		<div class="col-12 pl-0 pr-0">
			<div class="col-12 pt-3 pl-2 pr-2 d-flex">
				<div class="col-8 pl-0 mt-auto mb-auto font-size-12 font-size-sm-11">Keranjang Belanja</div>
				<div class="col-4 rounded-pill bg-blue font-size-10 color-white m-auto pt-1 pb-1 text-center">{{ total_cart }} Item</div>
			</div>
			<div class="col-12 pl-2 pr-2">
				<div class="col-12 pt-3 border-bottom"></div>
			</div>
		</div>
		<div class="col-12 pl-0 pr-0 font-size-11 color-gray-2"
			:class="{ 'shop-cart-item': discount_rebate_value == 0, 'shop-cart-item-minify': discount_rebate_value > 0 }"
			id="shop-cart-container">
			<div class="col-12 pl-0 pr-0 d-flex flex-wrap justify-content-center" v-if="cart.length < 1">
				<div class="col-6 col-md-12 pl-0 pr-0 pt-4 text-center">
					<img class="img-fluid" src="/assets/transaction/keranjang-belanja-kosong.png">
				</div>
				<div class="col-12 pl-0 pr-0 text-center pt-2 font-size-sm-10">Keranjang Belanja Anda masih kosong...</div>
			</div>
			<div class="col-12 pl-0 pr-0 text-center"
				:class="{ 'shop-cart-item': discount_rebate_value == 0, 'shop-cart-item-minify': discount_rebate_value > 0 }"
				v-if="cart.length > 0">
				<div class="col-12 pl-2 pr-2 pt-3 d-flex" v-for="(value, index) in cartShow" :key="index">
					<div class="col-2 pl-0 mt-auto mb-auto"><img class="img-fluid" :src="value.product_image"></div>
					<div class="col-9 pl-0 text-left">
						<div class="col-12 font-size-10 color-black">{{ value.product_name }}</div>
						<div class="col-12 font-size-9 color-gray-2">{{ value.price | toRupiah }}</div>
						<div v-if="step == 0" class="col-12 pt-1 d-flex justify-content-start">
							<button @click="minQty(index)" class="btn p-0 color-blue no-box-focus btn-hover ml-2 mt-n1">
								<span class="font-size-16"><i class="fas fa-minus-circle"></i></span>
							</button>
							<input @keypress="onlyNumber" @paste.prevent v-model="value.quantity" @change="cekQty(index)" type="text"
								class="col-4 form-control form-control-sm font-size-9 font-weight-bold no-box-focus text-center">
							<button @click="addQty(index)" class="btn p-0 color-blue ml-2 mt-n1">
								<span class="font-size-16"><i class="fas fa-plus-circle"></i></span>
							</button>
						</div>
					</div>
					<div class="col-1 text-right mt-auto mb-auto">
						<span @click="deleteCart(value.product_id)" v-show="step == 0" class="cursor-pointer color-red"><i
								class="fas fa-trash"></i></span>
						<span v-show="step > 0" class="">{{ value.quantity }}</span>
					</div>
				</div>
			</div>
		</div>
		<div v-show="cart.length > 0" class="col-12 pl-0 pr-0 mt-2 font-size-11">
			<div class="col-12 pl-2 pr-2">
				<div class="col-12 pt-1 border-top"></div>
			</div>
			<div class="col-12 pl-2 pr-2 d-flex color-gray-2">
				<div class="col-6 pl-0">Subtotal</div>
				<div class="col-6 pr-0 text-right">{{ price_subtotal | toRupiah }}</div>
			</div>
			<!-- <div class="col-12 pl-2 pr-2 pt-2 d-flex color-gray-2" v-if="(!mitra || register) && Object.values(registerItem).length > 0">
				<div class="col-7 pl-0" v-html="registerItem.title.replace(/[(]/g, '<br>(')"></div>
				<div class="col-5 pr-0 text-right">{{ registerItem.price | toRupiah}}</div>
			</div> -->
			<div class="col-12 pl-2 pr-2">
				<div class="col-12 pt-1 border-bottom"></div>
			</div>
		</div>
		<div v-show="cart.length > 0" class="col-12 pl-0 pr-0 mt-1 font-size-11">
			<div v-if="shipping_cost > 0">
				<div class="col-12 pl-2 pr-2 d-flex color-gray-2">
					<div class="col-6 pl-0">Tambahan Ongkos Kirim</div>
					<div class="col-6 pr-0 text-right">{{ shipping_cost | toRupiah }}</div>
				</div>
				<div class="col-12 pl-2 pr-2">
					<div class="col-12 pt-1 border-bottom"></div>
				</div>
			</div>
		</div>
		<div v-show="cart.length > 0" class="col-12 pl-0 pr-0 mt-1 font-size-11">
			<div v-if="discount_rebate_value > 0">
				<div class="col-12 pl-2 pr-2 d-flex color-gray-2">
					<div class="col-6 pl-0">Pot. Harga <span class="font-size-8 color-blue">{{ discount_rebate | toRupiah }} / BV</span></div>
					<div class="col-6 pr-0 text-right">{{ discount_rebate_value | toRupiah }}</div>
				</div>
				<div class="col-12 pl-2 pr-2">
					<div class="col-12 pt-1 border-bottom"></div>
				</div>
			</div>
		</div>
		<div v-show="cart.length > 0" class="col-12 pl-0 pr-0 mt-1 font-size-11">
			<div v-if="price_subtotal >= minimum_transaction_use_materai">
				<div class="col-12 pl-2 pr-2 d-flex color-gray-2">
					<div class="col-6 pl-0">Materai</div>
					<div class="col-6 pr-0 text-right">{{ materai_value | toRupiah }}</div>
				</div>
				<div class="col-12 pl-2 pr-2">
					<div class="col-12 pt-1 border-bottom"></div>
				</div>
			</div>
		</div>
		<div v-show="cart.length > 0" class="col-12 pl-0 pr-0 pb-0 pb-lg-0 mt-1 font-size-11">
			<div class="col-12 pl-2 pr-2 d-flex">
				<div class="col-6 pl-0">Total</div>
				<div class="col-6 pr-0 text-right">{{ price_total | toRupiah }}</div>
			</div>
		</div>
		<div v-show="cart.length > 0" class="col-12 pl-0 pr-0 mt-1 font-size-10 color-mila">
			<div class="col-12 pl-2 pr-2">
				<div class="col-12 pt-1 border-top"></div>
			</div>
			<div class="col-12 pl-2 pr-2 d-flex">
				<div class="col-6 pl-0">Total BV</div>
				<div class="col-6 pr-0 text-right">{{ bv_total | toNumber }}</div>
			</div>
		</div>
		<div v-show="cart.length > 0" class="col-12 pl-0 pr-0 mt-1 font-size-10 color-mila mb-5">
			<div class="col-12 pl-2 pr-2">
				<div class="col-12 pt-1 border-top"></div>
			</div>
			<div class="col-12 pl-2 pr-2 d-flex">
				<div class="col-6 pl-0">Minimum BV</div>
				<div class="col-6 pr-0 text-right">{{ minimumBV | toNumber }}</div>
			</div>
		</div>
		<!-- <div v-show="cart.length > 0" class="col-12 pl-0 pr-0 mt-2 font-size-8 color-mila">
			<div class="col-12 pl-2 pr-2">
				<div class="col-12 pt-2 border-top"></div>
			</div>
			<div class="col-12 pl-2 pr-2 d-flex">
				<div class="col-6 pl-0 pr-0 d-flex">
					<div class="col-8 pl-0 pr-0">Total BV</div>
					<div class="col-4 pl-0 pr-1 text-right border-right">{{bv_total | toNumber}}</div>
				</div>
				<div class="col-6 pl-0 pr-0 d-flex">
					<div class="col-8 pl-1 pr-0">Minimum BV</div>
					<div class="col-4 pl-0 pr-0 text-right">{{minimumBV | toNumber}}</div>
				</div>
			</div>
		</div> -->
		<!-- <div class="col-12 pl-0 pr-0 btn-cart" v-if="step == 1">
			<button :disabled="cart.length == 0" class="col-12 btn bg-blue color-white no-box-focus" @click="lanjut">
				<div class="d-flex justify-content-center pt-1 pb-1">
					<div class="mr-2 font-size-11 font-weight-bold">Selanjutnya</div>
					<i class="fas fa-arrow-right mt-1"></i>
				</div>
			</button>
		</div> -->
		<div class="col-12 pl-0 pr-0 btn-cart-twin" v-if="step == 0">
			<!-- <button class="col-4 btn bg-red color-white no-box-focus" @click="step_down" v-if="step > 0">
				<div class="d-flex justify-content-center pt-1 pb-1">
					<i class="fas fa-arrow-left mt-1"></i>
					<div class="ml-2 font-size-11 font-weight-bold">Kembali</div>
				</div>
			</button> -->
			<button :disabled="step == 0 && cart.length == 0 || bv_total < minimumBV" class="col-12 btn bg-blue color-white no-box-focus"
				@click="lanjut">
				<div class="d-flex justify-content-center pt-1 pb-1">
					<div class="mr-2 font-size-11 font-weight-bold">Selanjutnya</div>
					<i class="fas fa-arrow-right mt-1"></i>
				</div>
			</button>
		</div>
		<div class="col-12 pl-0 pr-0 btn-cart-twin" v-if="(step == 1)">
			<button class="col-4 btn bg-red color-white no-box-focus" @click="step_down">
				<div class="d-flex justify-content-center pt-1 pb-1">
					<i class="fas fa-arrow-left mt-1"></i>
					<div class="ml-2 font-size-11 font-weight-bold">Kembali</div>
				</div>
			</button>
			<button :disabled="paymentProgress == false" class="col-8 btn bg-blue color-white no-box-focus" @click="bayarConfirm">
				<div class="d-flex justify-content-center pt-1 pb-1">
					<div class="mr-2 font-size-11 font-weight-bold">Simpan</div>
					<i class="fas fa-arrow-right mt-1"></i>
				</div>
			</button>
		</div>
		<!-- <div class="col-12 pl-0 pr-0 btn-cart-twin" v-if="step == 4">
			<a :href="responsePaymentPdf" target="_blank" class="col-6 btn bg-light-blue color-white no-box-focus">
				<div class="d-flex justify-content-center pt-1 pb-1">
					<i class="fas fa-print mt-1"></i>
					<div class="ml-2 font-size-11 font-weight-bold">Cetak Invoice</div>
				</div>
			</a>
			<button class="col-6 btn bg-blue color-white no-box-focus" @click="resetSemua">
				<div class="d-flex justify-content-center pt-1 pb-1">
					<div class="mr-2 font-size-11 font-weight-bold">Transaksi Kembali</div>
				</div>
			</button>
		</div> -->
		<div class="col-12 pl-0 pr-0 btn-cart-twin" v-if="step == 2">
			<button class="col-12 btn bg-blue color-white no-box-focus" @click="resetSemua">
				<div class="d-flex justify-content-center pt-1 pb-1">
					<div class="mr-2 font-size-11 font-weight-bold">Belanja Kembali</div>
				</div>
			</button>
		</div>

		<i-modal ref="modalConfirmationPayment" class="modal-small">
			<template v-slot:header>
				<div></div>
			</template>
			<template v-slot:body>
				<AlertModal title="Konfirmasi" :message="confirmMessagePayment" type="confirmation" @remove="resetConfirmMessagePayment"
					@confirm="bayar" />
			</template>
			<template v-slot:footer>
				<div class="footer-modal">
					<div></div>
				</div>
			</template>
		</i-modal>

	</div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import validator from 'validator';
import IModal from '@/components/IModal.vue';
import AlertModal from '@/components/elements/alert/AlertModal.vue';

export default {
	components: {
		IModal, AlertModal
	},
	data() {
		return {
			kosong: false,
			minimum_transaction_use_materai: 5000000,
			materai_value: 10000,
			so_materai: 0,
			discount_rebate_value: 0,
			discount_bv: 0,
			discount_rebate: 0,
			confirmMessagePayment: '',
			// progressive_price: {
			// 	bv_total: 0,
			// 	rebate_bv: 0,
			// 	rebate_price: 0,
			// 	rebate_total: 0,
			// }
		}
	},
	props: {
		registrationData: {
			type: Object
		},
		alert: {
			type: Object
		}
	},
	computed: {
		...mapState('po_cart', ['step', 'cart', 'dataSerial', 'mitra', 'register', 'alertKeranjang', 'selectedPayment', 'selectedPaymentValue', 'payTotal', 'progressBayar', 'registerItem', 'responsePaymentPdf', 'dataProduk', 'serialOptionName', 'paymentProgress', 'warehouseId', 'minimumBV', 'customer_bank', 'customer_bank_split_payment', 'payment_method', 'payment_method_value', 'payment_split_payment_method_value', 'progressivePrice', 'progressive_price_data', 'shipping_cost']),
		...mapState('commonList', ['mitraMLM', 'mandatoryError']),
		...mapState('auth', ['userData']),

		total_cart() {
			if (this.cart) {
				return this.cart.length
			}
			return 0;
		},
		price_subtotal() {
			let price_total = 0
			if (this.cart) {
				this.cart.forEach(el => {
					price_total += parseInt(el.price) * parseInt(el.quantity)
				});
			}
			return price_total;
		},
		price_total() {
			let price_total = 0
			if (this.cart) {
				this.cart.forEach(el => {
					price_total += parseInt(el.price) * parseInt(el.quantity)
				});

				price_total = price_total + this.shipping_cost - this.discount_rebate_value

				if (price_total >= this.minimum_transaction_use_materai) {
					price_total += this.materai_value
				}
			}
			return price_total;
		},
		dataProduct() {
			var product = this.cart.map((el) => {
				//console.log(el)
				//console.log(this.userData)

				let obj = {
					product_code: el.product_code,
					product_id: el.product_id,
					product_name: el.product_name,
					//product_price: el.product_price,
					product_unit: el.product_unit,
					product_bv: el.product_bv,
					quantity: el.quantity,
				}

				if (this.userData.stockist_order_count >= 4 || this.userData.stockist_level == 'mb') {
					obj.product_price = el.product_price_original
				} else {
					obj.product_price = el.product_price
				}

				return obj
			})
			return product
		},
		cartShow() {
			return this.cart.filter((el) => {
				//return el.quantity > 0
				return el
			})
		},
		bv_total() {
			let bv_total = 0
			if (this.cart) {
				this.cart.forEach(el => {
					bv_total += parseInt(el.product_bv) * parseInt(el.quantity)
				});
			}

			this.calculate_progressive_price(bv_total)

			return bv_total
		},
	},
	methods: {
		...mapMutations('po_cart', ['step_up', 'step_down', 'setAlertKeranjang', 'reset', 'paymentProgressAct', 'setProgressivePriceData', 'setShippingCost']),
		...mapActions('po_cart', ['changeCartQty', 'deleteCart', 'savePO', 'getShippingCost']),
		...mapMutations('commonList', ['setAlertMandatory']),
		...mapActions('commonList', ['checkMandatory', 'getmitraMLM']),

		resetSemua() {
			this.reset()
		},
		checkRegisterItem() {
			/*cek jumlah produk register di produk apakah cart register + 1 cukup dengan sisa stock*/

			//let registerProduct = this.dataProduk.find(element => element.product_code == this.registerItem.code)
			//let registerInCart = this.cart.find(element => element.product_code == this.registerItem.code)
			//let quantityRegister = registerInCart ? registerInCart.quantity : 0
			//if ((registerProduct.stock_pos - quantityRegister) >= 0) {
			this.step_up()
			//} else {
			//this.setAlertKeranjang(`Silahkan melakukan penambahan produk ${this.registerItem.name}`)
			//}
		},
		lanjut() {
			if (this.step == 0) {
				if (!this.register) {
					if (this.mitra) {
						this.validateCart()
					} else {
						this.validateData().then(() => {
							var filter = Object.values(this.alert).filter((el) => {
								return el != ""
							})
							if (filter.length == 0) {
								this.step_up()
							}
						})
					}
				} else {
					this.validateCart()
				}
			} else if (this.step == 1) {
				if (this.userData.stockist_trx_method !== 'system') {
					this.setAlertKeranjang(`Silakan beralih menggunakan Metode Transaksi Sistem untuk melanjutkan transaksi`)
				} else {
					if (this.dataSerial.length > 0) {
						this.dataSerial.forEach((element, index) => {
							if (element.max_qty != element.serial.length) {
								this.setAlertKeranjang(`Jumlah serial ${this.serialOptionName[element.type]} ${element.product_code} harus ${element.max_qty}`)
							}
							if (index == this.dataSerial.length - 1 && !this.alertKeranjang) {
								this.step_up()
							}
						});
					} else {
						this.step_up()
					}
				}
			}
		},
		validateCart() {
			this.cart.forEach((element, index) => {
				// if (parseInt(element.quantity) > parseInt(element.stock_pos)) {
				// 	this.setAlertKeranjang(`Jumlah ${element.product_name} Melebihi Stok`)
				// }
				if (index == this.cart.length - 1 && !this.alertKeranjang) {
					this.step_up()
				}
			});
		},
		validateData() {
			return new Promise(async (resolve) => {
				if (!this.registrationData.mitra_code) {
					this.alert.mitra_code = "Data tidak boleh kosong"
				} else {
					this.alert.mitra_code = ""
					this.getmitraMLM({
						member_network_mid: this.registrationData.mitra_code
					}).then(() => {
						if (!this.mitraMLM.status) {
							this.alert.mitra_code = 'Kode Mitra tidak ditemukan'
						}
					})
				}
				if (!this.registrationData.email) {
					this.alert.email = "Data tidak boleh kosong"
				} else if (!validator.isEmail(this.registrationData.email)) {
					this.alert.email = "Email tidak valid"
				} else {
					this.alert.email = ""
				}
				if (!this.registrationData.name) {
					this.alert.name = "Data tidak boleh kosong"
				} else {
					if (this.registrationData.name.length < 3) {
						this.alert.name = "Nama terlalu pendek"
					} else {
						this.alert.name = ""
					}
				}
				if (!this.registrationData.card_id) {
					this.setAlertMandatory({ type: 'ktp', data: "Data tidak boleh kosong" })
				} else if (!validator.isLength(this.registrationData.card_id, { min: 16, max: 16 })) {
					this.setAlertMandatory({ type: 'ktp', data: "KTP tidak valid" })
				} else {
					await this.checkMandatory({ type: 'ktp', data: this.registrationData.card_id })
				}
				if (!this.registrationData.mobilephone) {
					this.setAlertMandatory({ type: 'hp', data: "Data tidak boleh kosong" })
				} else if (!validator.isLength(this.registrationData.mobilephone, { min: 10, max: 15 })) {
					this.setAlertMandatory({ type: 'hp', data: "Nomor tidak valid" })
				} else {
					await this.checkMandatory({ type: 'hp', data: this.registrationData.mobilephone })
				}
				resolve()
			})
		},
		cekQty(index) {
			this.changeCartQty({
				type: '',
				index: index
			})
		},
		minQty(index) {
			this.changeCartQty({
				type: 'min',
				index: index
			})
		},
		addQty(index) {
			this.changeCartQty({
				type: 'plus',
				index: index
			})
		},
		bayar() {
			if (!this.selectedPayment.value) {
				this.setAlertKeranjang(`Silahkan Pilih Metode Pembayaran`)
			} else {
				let payment = []
				this.paymentProgressAct(false)
				//let warehouse_id = this.warehouseId
				//let product = [... this.dataProduct]
				let product = this.dataProduct.map((el) => {
					var product = {
						product_name: el.product_name,
						product_id: el.product_id,
						quantity: el.quantity,
						price: el.product_price,
						product_bv: el.product_bv * el.quantity,
					}

					return product
				})

				//let payment_method = this.selectedPayment.value
				//console.log(this.selectedPayment)
				//console.log(this.selectedPaymentValue)

				let payment_method_text = this.selectedPayment.text
				let payment_method_value = this.selectedPaymentValue
				let payment_name = payment_method_value

				if (this.payment_method == '2') {
					payment_name = this.selectedPaymentValue.toUpperCase()
				}

				if (this.payment_method !== 3) {
					var nama_bank_asal = payment_name
					if (payment_name != '') {
						var payment_name_split = payment_name.split(' ')
						if (payment_name_split[0] != 'Bank') {
							nama_bank_asal = payment_method_text + ' ' + payment_name
						}
					}

					payment = [
						{
							payment_name: nama_bank_asal,
							payment_value: this.price_total
						}
					]
				} else {
					payment = []
					this.customer_bank_split_payment.forEach((el, index) => {
						let bank_name = 'Bank ' + el.customer_bank_name
						if (index == 0) {
							bank_name = 'Split Payment - Bank ' + el.customer_bank_name
						}
						payment.push({
							payment_name: bank_name,
							payment_value: el.customer_bank_transfer_amount
						})
					})
				}

				if (this.price_subtotal >= this.minimum_transaction_use_materai) {
					this.so_materai = this.materai_value
				}

				let params = {
					//warehouse_id: warehouse_id,
					product: product,
					payment: payment,
					discount_percentage: 0,
					discount_value: 0,
					rebate_value: this.discount_rebate_value,
					note: '',
					payment_method: this.payment_method,
					payment_method_value: this.payment_method_value,
					customer_bank_name: this.customer_bank.customer_bank_name,
					customer_bank_customer_name: this.customer_bank.customer_bank_customer_name,
					customer_bank_customer_number: this.customer_bank.customer_bank_customer_number,
					customer_split_payment: this.customer_bank_split_payment,
					payment_split_payment_method_value: this.payment_split_payment_method_value,
					materai_value: this.so_materai,
					//progressive_price: this.progressive_price
					bv_total: this.progressive_price_data.bv_total,
					rebate_bv: this.progressive_price_data.rebate_bv,
					rebate_price: this.progressive_price_data.rebate_price,
					rebate_total: this.progressive_price_data.rebate_total,
					delivery_fee: this.shipping_cost,
				}

				//console.log(params)

				this.savePO(params)
				this.resetConfirmMessagePayment()
			}
		},
		calculate_progressive_price(bv_total) {
			if (this.progressivePrice && bv_total > 0) {
				//console.log(this.progressivePrice)
				//console.log('calculate_progressive_price: ' + bv_total + 'BV')

				let progressive_bv = 0
				let progressive_rebate = 0

				this.progressivePrice.forEach(el => {
					if (bv_total >= el.bv && el.bv > progressive_bv) {
						progressive_bv = parseInt(el.bv)
						progressive_rebate = parseInt(el.rebate)
					}
				})

				if (progressive_bv > 0) {
					this.discount_rebate_value = progressive_rebate * bv_total
					this.discount_bv = progressive_bv
					this.discount_rebate = progressive_rebate

					this.setProgressivePriceData({
						bv_total: bv_total,
						rebate_bv: this.discount_bv,
						rebate_price: progressive_rebate,
						rebate_total: this.discount_rebate_value,
					})
				} else {
					this.discount_rebate_value = 0
					this.discount_bv = 0
					this.discount_rebate = 0
				}
			}
		},
		async calculateShippingCost(item) {
			const results = await Promise.all(
				item.map(async (el) => {
					const res = await this.getShippingCost({
						product_id: el.product_id,
						province_id: this.userData.stockist_origin_province_id
					})

					return res
						? el.quantity * res.results.shipping_area_price
						: 0
				})
			)

			const shipping_price = results.reduce((sum, price) => sum + price, 0)
			this.setShippingCost(shipping_price)
		},
		bayarConfirm() {
			this.confirmMessagePayment = 'Apakah produk yang akan dipesan sudah sesuai?'
			this.$refs.modalConfirmationPayment.modalShow()
		},
		resetConfirmMessagePayment() {
			this.confirmMessagePayment = ''
			this.$refs.modalConfirmationPayment.modalHide()
		}
	},
	watch: {
		mandatoryError: {
			deep: true,
			handler: function (val) {
				if (!this.mitra) {
					this.alert.card_id = val.ktp
					this.alert.mobilephone = val.hp
				}
			}
		},
		cart: {
			handler: async function (newVal, oldVal) {
				if (!oldVal) return

				await this.calculateShippingCost(newVal)
			},
			deep: true
		}
	}
};
</script>

<style scoped></style>
